import React from 'react'
import PropTypes from 'prop-types'
import { branch } from 'baobab-react/higher-order'
import BaseTemplate from 'components/templates/BaseTemplate'

const StaticHtml = ({ data }) => (
  <BaseTemplate noBreadcrumb useNewHeader>
    <div
      id="StaticHtml"
      dangerouslySetInnerHTML={{ __html: data }}
    />
  </BaseTemplate>
)

StaticHtml.propTypes = {
  data: PropTypes.string,
}

StaticHtml.defaultProps = {
  data: '',
}

export { StaticHtml }
export default branch({
  data: ['serverProps', 'data'],
}, StaticHtml)
